export default function replaceclass(
  el: HTMLElement | undefined,
  classname: string,
  replacewith: string
) {
  if (el) {
    var attr = el.getAttribute("class")
    if (attr && attr.includes(classname)) {
      attr = attr.replace(classname, replacewith)
      el.setAttribute("class", attr)
    }
  }
}
